import { Tabs } from '@material-ui/core';
import { AutocompleteInput, Button, NumberInput, ReferenceInput, SelectInput, TextInput } from "react-admin";
import "./form";

TextInput.defaultProps["fullWidth"] = true;
SelectInput.defaultProps["fullWidth"] = true;
ReferenceInput.defaultProps["fullWidth"] = true;
AutocompleteInput["defaultProps"] = AutocompleteInput["defaultProps"] || {};
AutocompleteInput["defaultProps"]["matchSuggestion"] = () => true;
AutocompleteInput["defaultProps"]["resettable"] = "true";
NumberInput.defaultProps.step = 10;
NumberInput.defaultProps.min = 0;
NumberInput.defaultProps.fullWidth = true;
Button.defaultProps.size = "medium";
// margin
TextInput.defaultProps["margin"] = "none";
SelectInput.defaultProps["margin"] = "none";
ReferenceInput.defaultProps["margin"] = "none";
NumberInput.defaultProps.margin = "none";

Tabs["defaultProps"] = Tabs["defaultProps"] || {};
Tabs["defaultProps"]["indicatorColor"] = "primary";